import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_API_URL;

function formatTime(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
}

export default function Presenze() {
  const { utente } = useAuth();
  const [data, setData] = useState(new Date().toISOString().split('T')[0]);
  const [presenze, setPresenze] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sedi, setSedi] = useState([]);
  const [reparti, setReparti] = useState([]);
  const [filtroPdf, setFiltroPdf] = useState('presenti'); // presenti | assenti | tutti
  const [filtroSede, setFiltroSede] = useState('');
  const [filtroReparto, setFiltroReparto] = useState('');
  const [sezione, setSezione] = useState('riepilogo'); // riepilogo | presenti | assenti

  useEffect(() => {
    axios.get(`${API}/sedi`).then(r => setSedi(r.data || [])).catch(() => {});
    axios.get(`${API}/reparti`).then(r => setReparti(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    carica();
  }, [data, filtroSede, filtroReparto]);

  const carica = async () => {
    setLoading(true);
    try {
      let url = `${API}/presenze?data=${data}`;
      if (filtroSede) url += `&sede_id=${filtroSede}`;
      if (filtroReparto) url += `&reparto_id=${filtroReparto}`;
      const res = await axios.get(url);
      setPresenze(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const repartiFiltrati = reparti.filter(r =>
    !filtroSede || r.field === filtroSede || r.Sede === filtroSede
  );

  const oggi = new Date().toISOString().split('T')[0];
  const ieri = new Date(Date.now() - 86400000).toISOString().split('T')[0];

  return (
    <div style={{ padding: '24px 16px', paddingBottom: 90 }}>
      <h2 style={{ color: '#f1f5f9', fontSize: 22, fontWeight: 800, marginBottom: 6 }}>Presenze</h2>
      <p style={{ color: '#64748b', fontSize: 14, marginBottom: 20 }}>Riepilogo giornaliero presenti e assenti</p>

      {/* Selezione data rapida */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        {[['oggi', oggi], ['ieri', ieri]].map(([label, val]) => (
          <button key={val} onClick={() => setData(val)}
            style={{ padding: '8px 16px', borderRadius: 10, border: `1px solid ${data === val ? '#f59e0b' : '#334155'}`, background: data === val ? '#f59e0b18' : 'transparent', color: data === val ? '#f59e0b' : '#64748b', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            {label.charAt(0).toUpperCase() + label.slice(1)}
          </button>
        ))}
        <input type="date" value={data} onChange={e => setData(e.target.value)}
          style={{ flex: 1, padding: '8px 12px', background: '#1e293b', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 13, outline: 'none' }} />
      </div>

      {/* Filtro sede */}
      <select value={filtroSede} onChange={e => { setFiltroSede(e.target.value); setFiltroReparto(''); }}
        style={{ width: '100%', padding: '10px 12px', background: '#1e293b', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 14, marginBottom: 10, boxSizing: 'border-box', outline: 'none' }}>
        <option value="">Tutte le sedi</option>
        {sedi.map(s => <option key={s.id} value={s.id}>{s.Nome}</option>)}
      </select>

      {/* Filtro reparto */}
      <select value={filtroReparto} onChange={e => setFiltroReparto(e.target.value)}
        style={{ width: '100%', padding: '10px 12px', background: '#1e293b', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 14, marginBottom: 20, boxSizing: 'border-box', outline: 'none' }}>
        <option value="">Tutti i reparti</option>
        {repartiFiltrati.map(r => <option key={r.id} value={r.id}>{r.Nome}</option>)}
      </select>

      {loading ? (
        <p style={{ color: '#475569', textAlign: 'center', padding: 30 }}>Caricamento...</p>
      ) : presenze ? (
        <>
          {/* Riepilogo numerico */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 20 }}>
            {[
              { label: 'PRESENTI', value: presenze.num_presenti, color: '#10b981' },
              { label: 'ASSENTI', value: presenze.num_assenti, color: '#ef4444' },
              { label: 'IN AZIENDA', value: presenze.in_azienda, color: '#f59e0b' },
            ].map(({ label, value, color }) => (
              <div key={label} style={{ background: '#1e293b', borderRadius: 14, padding: 14, border: `1px solid ${color}33`, textAlign: 'center' }}>
                <p style={{ color: '#64748b', fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', margin: '0 0 6px' }}>{label}</p>
                <p style={{ color, fontSize: 28, fontWeight: 800, margin: 0 }}>{value}</p>
              </div>
            ))}
          </div>

          {/* Tab presenti/assenti */}
          <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
            {[['presenti', `✅ Presenti (${presenze.num_presenti})`], ['assenti', `❌ Assenti (${presenze.num_assenti})`]].map(([v, l]) => (
              <button key={v} onClick={() => setSezione(v)}
                style={{ flex: 1, padding: '10px', borderRadius: 10, border: `1px solid ${sezione === v ? '#f59e0b' : '#334155'}`, background: sezione === v ? '#f59e0b18' : 'transparent', color: sezione === v ? '#f59e0b' : '#64748b', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                {l}
              </button>
            ))}
          </div>

          {/* Lista presenti */}
          {sezione === 'presenti' && (
            presenze.presenti.length === 0 ? (
              <p style={{ color: '#475569', textAlign: 'center', padding: 20 }}>Nessun presente</p>
            ) : presenze.presenti.map(p => (
              <div key={p.id} style={{ background: '#1e293b', borderRadius: 12, padding: '12px 14px', marginBottom: 8, border: '1px solid #10b98133' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                      {p.in_azienda && <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#10b981', display: 'inline-block' }} />}
                      <p style={{ color: '#f1f5f9', fontSize: 14, fontWeight: 700, margin: 0 }}>{p.nome} {p.cognome}</p>
                    </div>
                    <p style={{ color: '#475569', fontSize: 12, margin: 0 }}>{p.reparto} · {p.sede}</p>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    {p.ore_lavorate && (
                      <p style={{ color: '#f59e0b', fontSize: 13, fontWeight: 700, margin: '0 0 2px' }}>{p.ore_lavorate}</p>
                    )}
                    <p style={{ color: '#64748b', fontSize: 11, margin: 0 }}>
                      {formatTime(p.ingresso)} → {formatTime(p.uscita)}
                    </p>
                  </div>
                </div>
              </div>
            ))
          )}

          {/* Lista assenti */}
          {sezione === 'assenti' && (
            presenze.assenti.length === 0 ? (
              <p style={{ color: '#475569', textAlign: 'center', padding: 20 }}>Nessun assente</p>
            ) : presenze.assenti.map(a => (
              <div key={a.id} style={{ background: '#1e293b', borderRadius: 12, padding: '12px 14px', marginBottom: 8, border: '1px solid #ef444433' }}>
                <p style={{ color: '#f1f5f9', fontSize: 14, fontWeight: 700, margin: '0 0 4px' }}>{a.nome} {a.cognome}</p>
                <p style={{ color: '#475569', fontSize: 12, margin: 0 }}>{a.reparto} · {a.sede}</p>
              </div>
            ))
          )}
        </>
      ) : null}
    </div>
  );
}
